import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import Jumbotron from '@sprinx/react-web/Jumbotron';
import JumbotronSlide from '@sprinx/react-web/JumbotronSlide';
import ProductImageDecorated from '../ProductImageDecorated';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'SxProductImageGalleryNarrow'
});

function ProductImageGalleryNarrow(_ref) {
  var adornments = _ref.adornments,
      pClasses = _ref.classes,
      className = _ref.className,
      JumbotronProps = _ref.JumbotronProps,
      JumbotronSlideProps = _ref.JumbotronSlideProps,
      mediaTypeComponents = _ref.mediaTypeComponents,
      PrimaryImageProps = _ref.PrimaryImageProps,
      _ref$PrimaryImageComp = _ref.PrimaryImageComponent,
      PrimaryImageComponent = _ref$PrimaryImageComp === void 0 ? ProductImageDecorated : _ref$PrimaryImageComp,
      product = _ref.product,
      rest = _objectWithoutProperties(_ref, ["adornments", "classes", "className", "JumbotronProps", "JumbotronSlideProps", "mediaTypeComponents", "PrimaryImageProps", "PrimaryImageComponent", "product"]);

  var classes = useStyles({
    classes: pClasses
  });

  var _React$useMemo = React.useMemo(function () {
    var image = product.image,
        name = product.name,
        _product$media = product.media,
        media = _product$media === void 0 ? [] : _product$media;
    if (!image && !media.length) return [[]];
    var imgd = image ? {
      src: image,
      alt: name,
      type: 'image',
      index: 0
    } : {};
    return [[imgd].concat(_toConsumableArray(media)).filter(function (i) {
      return !!i.src;
    }).map(function (i, index) {
      return _extends({
        index: index
      }, i);
    }), name];
  }, [product]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      allMedia = _React$useMemo2[0],
      defaultAlt = _React$useMemo2[1];

  return /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement(Jumbotron, _extends({
    size: 'auto',
    autoplay: false,
    pagination: true
  }, JumbotronProps), (allMedia || []).map(function (i, index) {
    return /*#__PURE__*/React.createElement(JumbotronSlide, _extends({
      size: 's40'
    }, JumbotronSlideProps, {
      key: index.toString()
    }), /*#__PURE__*/React.createElement(PrimaryImageComponent, _extends({
      size: "big"
    }, PrimaryImageProps, adornments, {
      active: true,
      alt: i.alt || defaultAlt,
      mediaTypeComponents: mediaTypeComponents,
      src: i.src,
      stream: i.stream,
      type: i.type
    })));
  })));
}

ProductImageGalleryNarrow.propTypes = {
  adornments: PropTypes.shape({
    adornmentAsideLeft: PropTypes.node,
    adornmentAsideRight: PropTypes.node,
    adornmentInsideBottomLeft: PropTypes.node,
    adornmentInsideBottomRight: PropTypes.node,
    adornmentInsideTopLeft: PropTypes.node,
    adornmentInsideTopRight: PropTypes.node
  }),
  classes: PropTypes.shape({
    root: PropTypes.string
  }),
  className: PropTypes.string,
  JumbotronProps: PropTypes.shape({}),
  JumbotronSlideProps: PropTypes.shape({}),
  mediaTypeComponents: PropTypes.shape({}),
  PrimaryImageComponent: PropTypes.elementType,
  PrimaryImageProps: PropTypes.shape({}),
  product: PropTypes.shape({
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]),
    media: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string.isRequired,
        text: PropTypes.string
      }))]),
      src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]).isRequired,
      stream: PropTypes.string,
      type: PropTypes.string
    })),
    name: PropTypes.arrayOf(PropTypes.shape({
      language: PropTypes.string.isRequired,
      text: PropTypes.string
    }))
  }).isRequired
};
ProductImageGalleryNarrow.defaultProps = {
  adornments: undefined,
  classes: undefined,
  className: undefined,
  JumbotronProps: undefined,
  JumbotronSlideProps: undefined,
  mediaTypeComponents: undefined,
  PrimaryImageComponent: undefined,
  PrimaryImageProps: undefined
};
export default ProductImageGalleryNarrow;